<header
  class="hero-wrapper"
  [attr.aria-label]="ariaLabel()"
  [class.hero-wrapper__image]="!!backgroundImageStyle()"
  [ngStyle]="{
    backgroundImage: backgroundImageStyle(),
  }"
>
  <div
    class="container hero-wrapper__container"
    [class.hero-wrapper__container--large]="large()"
  >
    <div
      class="row hero-wrapper__row"
      [class.hero-wrapper__row--large]="large()"
    >
      <ng-content />
    </div>
  </div>
</header>
